import { select, all, call, put, takeLatest } from 'redux-saga/effects'

import {
    actions,
    getCitiesDataSuccess,
    getCitiesDataFailed,
    getHomeFaqsDataSuccess,
    getHomeFaqsDataFailed,
} from './actions'
import { citiesUrl, faqsUrl } from './urls'
import { api } from 'network/api'
import { getFAQsKey, isEqual } from 'utils/appUtils'
import { getItemIfHashCodeMatches, setItem } from 'utils/storageUtils'

const homeFaqsBaseParams = {
    app: '7now_landing',
    version: '1',
}

//= ============================================================================================================

function* fetchCities(action) {
    try {
        const { content } = yield select()
        if (content.get('cities').toJS().countryCode === action.countryCode) {
            // same country code, avoid reload
            return
        }

        const response = yield call(api, `${citiesUrl}?country=${action.countryCode}`, 'GET')
        yield put(
            getCitiesDataSuccess({
                countryCode: action.countryCode,
                data: response,
            })
        )
    } catch (error) {
        yield put(getCitiesDataFailed())
    }
}

function* fetchHomeFaqs(action) {
    try {
        const params = {
            language: action.language,
            ...homeFaqsBaseParams,
        }

        const { content } = yield select()
        const currentParams = content.get('faqs').toJS().params
        if (isEqual(currentParams, params)) {
            // same parameters, avoid reload
            return
        }

        const key = getFAQsKey()
        const storageObj = getItemIfHashCodeMatches(key)
        let response = storageObj.item
        if (!response) {
            // Send Accept-Language header with request
            response = yield call(
                api,
                `${faqsUrl}?app=${homeFaqsBaseParams.app}&version=${homeFaqsBaseParams.version}`,
                'GET',
                null,
                0,
                null,
                false,
                params.language
            )
            setItem(key, response, storageObj.hashCode)
        }
        yield put(
            getHomeFaqsDataSuccess({
                params,
                data: response,
            })
        )
    } catch (error) {
        yield put(getHomeFaqsDataFailed())
    }
}

//= ============================================================================================================

function* getCitiesWatcher() {
    yield takeLatest(actions.GET_CITIES, fetchCities)
}

function* getHomeFaqsWatcher() {
    yield takeLatest(actions.GET_HOME_FAQS, fetchHomeFaqs)
}

export default function* contentSaga() {
    yield all([
        // getCitiesWatcher(),
        getHomeFaqsWatcher(),
    ])
}
